<notify></notify>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#3699FF" type="ball-spin-clockwise-fade"
  fullScreen="true">
</ngx-spinner>

<kt-splash-screen></kt-splash-screen>

<router-outlet></router-outlet>